module.exports = __webpack_public_path__ + "static/media/tripadvisor.ae0d1ee0.svg";